<template>
  <div class="flex">
    <button
      type="button"
      @click="openModal"
      class="rounded-md bg-pohvBlue px-4 py-2 text-sm font-medium text-white cursor-pointer hover:bg-pohvBlue/80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75"
    >
      {{ buttonTitle }}
    </button>
  </div>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" @close="closeModal" class="relative z-10">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/25" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center p-4 text-center"
        >
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all flex flex-col gap-3"
            >
              <DialogTitle
                as="h3"
                class="text-lg font-medium leading-6 text-gray-900"
              >
                {{ title }}
              </DialogTitle>
              <div class="text-justify" v-html="content"></div>

              <div class="mt-6 flex">
                <button
                  type="button"
                  class="m-auto rounded-md border border-transparent bg-pohvBlue/20 px-4 py-2 text-sm font-medium text-pohvBlue cursor-pointer hover:bg-pohvBlue/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                  @click="closeModal"
                >
                  Sluiten
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
} from '@headlessui/vue'

defineProps<{
  title: string,
  buttonTitle: string,
  content: string
}>()

const isOpen = ref(false)

function closeModal() {
  isOpen.value = false
}
function openModal() {
  isOpen.value = true
}
</script>

<!-- <template>
      <Dialog :open="open" @close="close">
        <DialogPanel>
          <DialogTitle>Deactivate account</DialogTitle>
          <DialogDescription>
            This will permanently deactivate your account
          </DialogDescription>

          <p>
            Are you sure you want to deactivate your account? All of your data will be
            permanently removed. This action cannot be undone.
          </p>

          <button @click="close">Deactivate</button>
          <button @click="close">Cancel</button>
        </DialogPanel>
      </Dialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import {
    Dialog,
    DialogPanel,
    DialogTitle,
    DialogDescription,
  } from '@headlessui/vue'
defineProps<{
  isOpen: boolean
}>()

const open = ref(true)

function close() {

}
</script> -->
